(ns hypnos.sleeplab.tile.communications
  "Demographics tile."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.sleeplab.subs]
            [hypnos.sleeplab.tile.table.communication :as communication]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- load
  [body]
  (if-let [_ @(rf/subscribe [:sleeplab/gql-request-in-progress?])]
    [:div.card-content
     [:section.section
      [:div.content.has-text-grey.has-text-centered
       [:p
        [:span.icon.is-large
         [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
       [:p (tr :ui.label/loading)]]]]
    body))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn tile
  []
  [:div.tile.is-ancestor
   [:div.tile.is-parent
    [:div.card.tile.is-child
     [:header.header.card-header
      [:p.card-header-title (tr :ui.label/communications)]]
     (load
      [:div.card-content
       [communication/table]])]]])
